import { render } from "./marketsComponent.vue?vue&type=template&id=7c4b74c6&scoped=true"
import script from "./marketsComponent.vue?vue&type=script&lang=js"
export * from "./marketsComponent.vue?vue&type=script&lang=js"

import "./marketsComponent.vue?vue&type=style&index=0&id=7c4b74c6&scoped=true&lang=css"
import "./marketsComponent.vue?vue&type=style&index=1&id=7c4b74c6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4b74c6"]])

export default __exports__